module.exports = __webpack_public_path__ + "static/van2.4bcddd8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/van2.png
// module id = 292
// module chunks = 35783957827783 267625579013595